import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import { LabelValue } from '../_common';
import DateTimeDisplay from '../_common/DateTimeDisplay';
import History from '../_common/History/History';
import Notes from '../_common/Notes/Notes';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingContentAssembly } from '@/redux/selectors/packagingSelectors';

const PackagingMetadataBar = () => {
  const contentAssembly = useAppSelector(selectPackagingContentAssembly);

  return (
    <MetadataBox>
      <Grid container spacing={2}>
        <LabelValue label="Version Name">{contentAssembly?.version?.name || '-'}</LabelValue>
        <LabelValue label="Due Date">
          <DateTimeDisplay singleLine missingText={'-'}>
            {contentAssembly?.job?.due_date || null}
          </DateTimeDisplay>
        </LabelValue>
        <LabelValue label="Order ID">{contentAssembly?.job?.order?.hid || '-'}</LabelValue>
        <LabelValue label="Task ID">{contentAssembly?.hid || '-'}</LabelValue>
      </Grid>
      <RightAlignedGrid>
        <CommentHistoryBox>
          {contentAssembly && <StyledNotes data={contentAssembly} />}
          {contentAssembly && <StyledHistory data={contentAssembly} iconOnly />}
        </CommentHistoryBox>
      </RightAlignedGrid>
    </MetadataBox>
  );
};

export default PackagingMetadataBar;

const MetadataBox = styled(Box)`
  background: ${({ theme }) => theme.palette.primary.main + '3d'};
  padding: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const RightAlignedGrid = styled(Grid)`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(3)};
`;

const CommentHistoryBox = styled.div`
  background: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.palette.background.default : '#BDC3F2')};
  height: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(1.25)};
  border-radius: ${({ theme }) => theme.shape.borderRadius / 2}px;

  svg {
    color: ${({ theme }) => (theme.palette.mode === 'dark' ? 'white' : '#262834')};
  }
`;

const StyledNotes = styled(Notes)`
  svg {
    height: 17px;
  }

  .MuiIconButton-root {
    background: transparent;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

const StyledHistory = styled(History)`
  svg {
    height: 19px;
  }

  .MuiIconButton-root {
    background: transparent;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;
